import {TextField, InputLabel} from '@mui/material';
import React from 'react';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {useField, ErrorMessage, useFormikContext } from 'formik';


interface Props {
  name: string;
  inputLabel: string;
  className: string,
  placeholder:string, 
}
const DatePickerWrapper: React.FC<Props> = ({
  inputLabel,
  name,
  placeholder,
}) => {
  const { setFieldValue} = useFormikContext();
  const [field, meta] = useField(name);
  const [value1, setValue] = React.useState<null>(null);

  const changeHandler = (newValue:any)=> {
    setValue(newValue);
    setFieldValue(name, newValue)
  }

  const placeholdertext = {
    inputProps:{
      placeholder: placeholder
    }
  }

  return (
    <>
      <InputLabel htmlFor="grouped-native-select"
         className={
            meta && meta.touched && meta.error ? "error-color label datetimepickerlabel" : "label datetimepickerlabel"
          }
      >
        {inputLabel} <span style={{color:'red'}}>*</span></InputLabel>      
        <LocalizationProvider  dateAdapter={AdapterMoment }>
      <DatePicker
       {...placeholdertext}
        value={value1}
        disablePast
        onChange={changeHandler}
        renderInput={(params) => 
        <TextField 
          {...params} 
          error={meta && meta.touched && meta.error? true: false}
           />
        }
      />
    </LocalizationProvider>
    {meta && meta.touched && meta.error ?
       <ErrorMessage component='p' name={name}   className = "select-error error-color fs-14"/>
       : null
    }
    </>
  );
};

export default DatePickerWrapper;
